import './App.css';
import {useEffect, useState} from "react";
import ScaleLoader from "react-spinners/ScaleLoader";


function App() {
  let [loading] = useState(true);
  let [color] = useState("#ffffff");
  const authenticationPage = 'https://mightyjaxx.com/authenticate'

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    try {
      if (queryParams) {
        console.log(window.location.search)
        console.log(queryParams);
        const open = queryParams.get('open') || '';
        const productHandle = queryParams.get('product-handle') || '';
        const qrCodeData = queryParams.get('d');
        const campaignSlug = queryParams.get('campaign-slug');
        const qrcodeAction = !campaignSlug? 'authenticate' : '';
        const oneLinkURL = "https://mightyjaxx.onelink.me/Z9LC";
        const oneLinkUrlNoAuthenticatePage = "https://pdp.onelink.me/rKOq/4xfsn1do"
        const campaignUrPage = "https://the-grand-voyage.onelink.me/6MMw/vepz90hf"
        var mediaSource = {keys: ["my_media_source"], defaultValue: "my_default_media_source"};
        var campaign = {keys: ["my_campaign"], defaultValue:  campaignSlug ?? "my_default_campaign"};
        const product_handle = {
          paramKey: 'product_handle',
          keys: ['product_handle'],
          defaultValue: productHandle,
        };
        const campaign_slug = {
          paramKey: 'campaign_slug',
          keys: ['campaign_slug'],
          defaultValue: campaignSlug,
        };
        const qr_code_action = {
          paramKey: 'qr_code_action',
          keys: ['qr_code_action'],
          defaultValue: qrcodeAction,
        };
        const qr_code_data = {
          paramKey: 'qr_code_data',
          keys: ['qr_code_data'],
          defaultValue: qrCodeData,
        };
        const deep_link_value = {
          paramKey: 'deep_link_value',
          keys: ['deep_link_value'],
          defaultValue: qrCodeData,
        };
        const deep_link_sub1 = {
          paramKey: 'deep_link_sub1',
          keys: ['deep_link_sub1'],
          defaultValue: qrCodeData,
        };
        const is_retargeting = {
          paramKey: 'is_retargeting',
          keys: ['is_retargeting'],
          defaultValue: true,
        };
        const deep_link_sub2 = {
          paramKey: 'deep_link_sub2',
          keys: ['deep_link_sub2'],
          defaultValue: qrcodeAction,
        };
        console.log(mediaSource);
        console.log(qr_code_action);
        console.log(qr_code_data);
        console.log(deep_link_value);
        console.log(campaign);
        console.log(product_handle);
        let oneLineUrl = open === 'pdp'? oneLinkUrlNoAuthenticatePage :oneLinkURL;
        if(campaignSlug){
          oneLineUrl = campaignUrPage
        }
        console.log('oneLineUrl: ', oneLineUrl);

        const result = window.AF_SMART_SCRIPT.generateOneLinkURL({
          oneLinkURL: oneLineUrl,
          af_ios_url: 'https://apps.apple.com/sg/app/mighty-jaxx-store/id1488637292',
          af_android_url: 'https://play.google.com/store/apps/details?id=com.mightyjaxx',
          afParameters: {
            c: campaign,
            mediaSource: mediaSource,
            afCustom: [
              mediaSource,
              qr_code_action,
              qr_code_data,
              deep_link_sub1,
              deep_link_sub2,
              deep_link_value,
              is_retargeting,
              product_handle,
              campaign_slug
            ]
          }
        });

        if (result.clickURL) {
          if(open === 'pdp'){
            window.location.href = result.clickURL;
          }else {
            const link = `${authenticationPage}?url=${encodeURIComponent(result.clickURL)}`
            window.location.href = link;
          }
        }
        console.log(result);
      }
    }catch (e) {
      console.log(e);
      window.location.href = authenticationPage;
    }
  }, []);

  return (
      <div className="App">
        <header className="App-header">
          <ScaleLoader
              color={color}
              loading={loading}
              size={150}
              aria-label="Loading Spinner"
              data-testid="loader"
          />
        </header>
      </div>
  );
}

export default App;
